export default {
    Auth: {
        // REQUIRED - Amazon Cognito Identity Pool ID
        identityPoolId: 'ap-southeast-2:b036caa0-5eb3-482c-93bb-277921325de8',
        // REQUIRED - Amazon Cognito Region
        region: 'ap-southeast-2',
        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'ap-southeast-2_8BiYz97Uy',
        // OPTIONAL - Amazon Cognito Web Client ID
        userPoolWebClientId: '6lag650s54asvjokutrrf91npp',
    },
    API: {
        aws_appsync_graphqlEndpoint: 'https://dqfulknguzhqzisf2tzxkvucke.appsync-api.ap-southeast-2.amazonaws.com/graphql',
        aws_appsync_authenticationType :'AMAZON_COGNITO_USER_POOLS',
        aws_appsync_region :'ap-southeast-2',
        endpoints: [{
            name: 'AnnalectDatalakeApi',
            endpoint: 'https://datalake.annalect.nz/v2',
            region: 'ap-southeast-2'
        }]
    },
    s3_bucket: 'annalect-datalake-applications',
    s3_file_prefix: 'uploads',
    s3_region: 'ap-southeast-2'
}


// WEBPACK FOOTER //
// ./src/Constants.js